import { isSignedInWithAzure, logoutWithAzure } from './azure';
import { logoutCognito } from './cognito';

export async function logout() {
  if (await isSignedInWithAzure()) {
    logoutWithAzure();
    return;
  } else {
    await logoutCognito();
  }
  globalThis.location.href = '/';
}
